/**
 * Resta meses a una fecha
 * @param date Fecha base
 * @param months Cantidad de meses a restar
 * @returns Nueva fecha con los meses restados
 */
export const subtractMonths = (date: Date, months: number): Date => {
  const result = new Date(date);
  result.setMonth(result.getMonth() - months);
  return result;
};

/**
 * Formatea una fecha local a YYYY-MM-DD
 * @param date Fecha a formatear
 * @returns Fecha en formato ISO local
 */
export const formatLocalDate = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};
